export const CONSTANTS = {
  SCREEN_GROUP: 'consignee',
  GRID_CONSIGNEE_LOOKUP_DIALOG: 'grid-consignee-lookup-dialog',
  GRID_CUSTOMER_CONSIGNEE_LOOKUP_DIALOG: 'grid-customer-consignee-lookup-dialog',
} as const;
